export const MUTATION_TYPES = {
  RESET: 'reset',
  SET_ACADEMIC_YEARS: 'setAcademicYears',
  SET_MONTHS: 'ssetMonths',
  SET_MONTHS_ORIGINAL: 'setMonthsOriginal',
  SET_SPECIALIST_OR_COMPANY: 'setSpecialistOrComapany',
  SET_ADDITIONAL_INFORMATION: 'setAdditionalInformation',
  SET_SPECIALIST: 'setSpecialist',
  SET_PROVIDERS: 'setProviders',

  //Advanced Filters
  SET_SERVICES: 'setServices',
  SET_CENTERS: 'setCenters',
  SET_LOCATIONSTYPE: 'setLocationsType',
  SET_LOCATION: 'setLocation',
  SET_SUPERVISED_SPECIALISTS: 'setSupervisedSpecialists',

  SET_RESULTS: 'setResults',
  SET_FILTERED_PERIOD: 'setFilteredPeriod',
  SET_VISIT_TYPES: 'setVisitTypes',
  SET_DOCUMENT_TYPES: 'setDocumentTypes',
  SET_PRACTITIONER: 'setPractitioner',
  SET_VISIT_ABSENCE_REGISTRATION: 'setVisitAbsenceRegistration',
  SET_VISIT_REGISTERED: 'setVisitRegistered',
  SET_VISITS: 'setVisits',
  SET_VISIT_ENTRY: 'setVisitEntry',
  SET_DELETE_VISIT: 'setDeleteVisit',
  SET_VISIT_VALID_REPLACEMENT: 'setVisitValidReplacement',
  SET_VISIT_VALID_REPOSITION: 'setVisitValidReposition',
  SET_FINALIZED_PERIOD: 'setFinalizedPeriod',
  SET_VISIT_VALIDATION_INFO: 'setVisitValidationInfo',
  SET_SPECIALIST_REPLACEMENT: 'setSpecialistReplacement',
  SET_VISIT_LIST: 'setVisitList',
  SET_VISIT_LOCATION: 'setVisitLocation',
  SET_VISIT_REGION: 'setVisitRegion',
  SET_VISIT_DISTRICT: 'setVisitDistrict',
  SET_VISIT_SCHOOL: 'setVisitSchool',
  SET_VISIT_MUNICIPALITIES: 'setVisitMunicipalities',
  SET_VISIT_LOCATION_SERVICE: 'setVisitLocationService',
  SET_VISIT_CENTER: 'setVisitCenter',
  SET_CLEAR_CATALOG: 'setClearCatalog',
  SET_SELECTED_PERIOD: 'setSelectedPeriod',
  SET_FILTER_PROP: 'SET_FILTER_PROP',
  SET_PREVIOUS_ACADEMIC_YEARS: 'SET_PREVIOUS_ACADEMIC_YEARS',
  SET_VISIT_FILTER: 'setVisitFilter',
};

export const ACTION_TYPES = {
  RESET: 'reset',
  GET_ACADEMIC_YEARS: 'getAcademicYears',
  GET_MONTHS: 'getMonths',
  GET_SPECIALIST_OR_COMPANY: 'getSpecialistOrComapany',
  GET_ADDITIONAL_INFORMATION: 'getAdditionalInformation',
  GET_SPECIALIST: 'getSpecialist',
  GET_PROVIDERS: 'getProviders',

  //Advanced Filters
  GET_SERVICES: 'getServices',
  GET_CENTERS: 'getCenters',
  GET_LOCATIONSTYPE: 'getLocationsType',
  GET_LOCATION: 'getLocation',
  GET_SUPERVISED_SPECIALISTS: 'getSupervisedSpecialists',

  RESET_ADVANCED_FILTERS: 'resetAdvancedFilters',
  SEARCH: 'search',
  GET_VISIT_TYPES: 'getVisitTypes',
  GET_EDUCATION_VISIT_TYPES: 'getEducationVisitTypes',
  GET_DOCUMENT_TYPES: 'getDocumentTypes',
  GET_PRACTITIONER: 'getPractitioner',
  GET_VISIT_ABSENCE_REGISTRATION: 'getVisitAbsenceRegistration',
  SAVE_VISIT: 'saveVisit',
  DELETE_VISIT: 'deleteVisit',
  GET_VISIT_VALID_REPLACEMENT: 'getVisitValidReplacement',
  GET_VISIT_VALID_REPOSITION: 'getVisitValidReposition',
  GET_FINALIZED_PERIOD: 'getFinalizedPeriod',
  VISIT_VALIDATION_INFO: 'visitValidationInfo',
  GET_VISITS: 'getVisits',
  GET_SPECIALIST_REPLACEMENT: 'getSpecialistReplacement',
  GET_VISIT_LOCATION: 'getVisitLocation',
  GET_VISIT_REGION: 'getVisitRegion',
  GET_VISIT_DISTRICT: 'getVisitDistrict',
  GET_VISIT_SCHOOL: 'getVisitSchool',
  GET_VISIT_MUNICIPALITIES: 'getVisitMunicipalities',
  GET_VISIT_LOCATION_SERVICES: 'getVisitLocationServices',
  GET_VISIT_CENTERS: 'getVisitCenters',
  SET_FILTERED_PERIOD: 'setFilteredPeriod',
  SET_CLEAR_CATALOG: 'setClearCatalog',
  SET_FILTER_PROP: 'SET_FILTER_PROP',
};
